module.exports = __webpack_public_path__ + "img/3ENG_Cover.b8f40ea1.jpg";